import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import emailjs from "emailjs-com";
import "react-calendar/dist/Calendar.css";
import "./calendrier.css";
import { saveMessage } from "../firebase";
import { MAISON_TXT_URL } from "../apiConfig";



// EmailJS
const EMAILJS_SERVICE_ID = "service_dh543em";
const EMAILJS_TEMPLATE_ID = "template_7cpaqti";
const EMAILJS_PUBLIC_KEY = "gSJYtIQrvMcxeHTbu";

// 👇 IMPORTANT : formatter en LOCAL (pas toISOString)
function toYMDLocal(dateObj) {
  const y = dateObj.getFullYear();
  const m = String(dateObj.getMonth() + 1).padStart(2, "0");
  const d = String(dateObj.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const CalendrierMaison = () => {
  const [dispos, setDispos] = useState({});
  const [selectedWeeks, setSelectedWeeks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    email: "",
    nom: "",
    prenom: "",
    personnes: "",
    telephone: "",
  });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  // date passée ?
  const isPastDay = (dayStr) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const [y, m, d] = dayStr.split("-").map(Number);
    const dt = new Date(y, m - 1, d, 0, 0, 0, 0);
    return dt < today;
  };

  // calcule la semaine SAMEDI -> VENDREDI pour une date donnée
  const getSatToFriWeekFromDate = (dateObj) => {
    const jsDay = dateObj.getDay(); // 0=dim ... 6=sam
    const daysToRemove = (jsDay + 1) % 7; // pour revenir au samedi
    const saturday = new Date(
      dateObj.getFullYear(),
      dateObj.getMonth(),
      dateObj.getDate() - daysToRemove
    );
    const result = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(
        saturday.getFullYear(),
        saturday.getMonth(),
        saturday.getDate() + i
      );
      result.push(toYMDLocal(d));
    }
    return result;
  };

  // 🔄 charger maison.txt
  useEffect(() => {
    fetch(MAISON_TXT_URL)
      .then((res) => {
        if (!res.ok) {
          console.warn("⚠️ getMaisonTxt non OK:", res.status);
          return null;
        }
        return res.text();
      })
      .then((text) => {
        if (!text) return;

        // 1) on lit le fichier -> explicitMap
        const explicitMap = {};
        const addDateExplicit = (dateStr, status) => {
          const already = explicitMap[dateStr];
          if (already && already.status === "reserved") return;
          if (status === "reserved") {
            explicitMap[dateStr] = { status: "reserved", hard: true };
          } else if (status === "blocked") {
            if (!already || already.status !== "reserved") {
              explicitMap[dateStr] = { status: "blocked", hard: true };
            }
          }
        };

        text
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l && !l.startsWith("#"))
          .forEach((line) => {
            const parts = line.split(" ");
            if (parts.length === 2) {
              const [dateStr, status] = parts;
              addDateExplicit(dateStr, status);
            } else if (parts.length === 4 && parts[1] === "to") {
              const [startStr, , endStr, status] = parts;
              const [ys, ms, ds] = startStr.split("-").map(Number);
              const [ye, me, de] = endStr.split("-").map(Number);
              const start = new Date(ys, ms - 1, ds);
              const end = new Date(ye, me - 1, de);
              for (
                let d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                d <= end;
                d.setDate(d.getDate() + 1)
              ) {
                addDateExplicit(toYMDLocal(d), status);
              }
            } else {
              console.warn("❌ ligne non reconnue:", line);
            }
          });

        // 2) on fabrique la map complète (année courante -> année + 2)
        const today = new Date();
        const currentYear = today.getFullYear();
        const startCal = new Date(currentYear, 0, 1); // 1 jan courant
        const endCal = new Date(currentYear + 2, 11, 31); // 31 déc +2

        const tempMap = {};

        for (
          let d = new Date(startCal.getFullYear(), startCal.getMonth(), startCal.getDate());
          d <= endCal;
          d.setDate(d.getDate() + 1)
        ) {
          const ds = toYMDLocal(d);
          if (explicitMap[ds]) {
            tempMap[ds] = { ...explicitMap[ds] };
          } else {
            if (isPastDay(ds)) {
              tempMap[ds] = { status: "blocked", hard: true };
            } else {
              tempMap[ds] = { status: "available", hard: false };
            }
          }
        }

        // 3) appliquer la règle "semaine complète"
        const finalMap = { ...tempMap };

        for (
          let d = new Date(startCal.getFullYear(), startCal.getMonth(), startCal.getDate());
          d <= endCal;
          d.setDate(d.getDate() + 1)
        ) {
          if (d.getDay() !== 6) continue; // seulement les samedis
          const weekDays = getSatToFriWeekFromDate(d);

          let fullAvailable = true;
          for (const dayStr of weekDays) {
            const info = finalMap[dayStr];
            if (!info || info.status !== "available") {
              fullAvailable = false;
              break;
            }
          }

          if (!fullAvailable) {
            // on bloque soft
            for (const dayStr of weekDays) {
              const info = finalMap[dayStr];
              if (!info) continue;
              if (info.status === "reserved") continue;
              if (info.hard) continue;
              finalMap[dayStr] = { status: "blocked", hard: false };
            }
          }
        }

        setDispos(finalMap);
      })
      .catch((err) => {
        console.warn("⚠️ erreur maison.txt:", err.message);
      });
  }, []);

  // clic calendrier
  const onClickDay = (dateObj) => {
    const ds = toYMDLocal(dateObj);
    const info = dispos[ds];
    if (!info || info.status !== "available") return;

    const week = getSatToFriWeekFromDate(dateObj);

    const already = selectedWeeks.some((w) => w[0] === week[0] && w[6] === week[6]);

    const newSelected = already
      ? selectedWeeks.filter((w) => !(w[0] === week[0] && w[6] === week[6]))
      : [...selectedWeeks, week];

    setSelectedWeeks(newSelected);
    setMessage(generateMessage(form, newSelected));
  };

  const tileClassName = ({ date }) => {
    const ds = toYMDLocal(date);

    if (selectedWeeks.some((w) => w.includes(ds))) return "selected";

    const info = dispos[ds];
    if (!info) return "blocked-soft";

    if (info.status === "reserved") return "reserved";
    if (info.status === "available") return "available";
    return info.hard ? "blocked-hard" : "blocked-soft";
  };

  const tileDisabled = ({ date }) => {
    const ds = toYMDLocal(date);
    const info = dispos[ds];
    return !(info && info.status === "available");
  };

  const handleReservation = () => {
    if (selectedWeeks.length === 0) {
      setError("❌ Veuillez sélectionner au moins une semaine.");
      return;
    }
    setError("");
    setShowForm(true);
  };

  const handleChange = (e) => {
    const newForm = { ...form, [e.target.name]: e.target.value };
    setForm(newForm);
    setMessage(generateMessage(newForm, selectedWeeks));
  };

  const generateMessage = (formData = form, weeks = selectedWeeks) => {
    const periodes = weeks.map((w) => `du ${w[0]} au ${w[6]}`).join(", ");
    return `Bonjour,

Je souhaiterais réserver "La Maison" pour la période ${periodes} pour ${
      formData.personnes || "___"
    } personnes.
Vous pouvez me contacter au ${formData.telephone || "___"}.

Cordialement,
${formData.prenom || "___"} ${formData.nom || "___"}
(${formData.email || "___"})`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.email ||
      !form.nom ||
      !form.prenom ||
      !form.personnes ||
      !form.telephone
    ) {
      setError("❌ Merci de remplir tous les champs.");
      return;
    }

    try {
      const periodes = selectedWeeks.map((w) => `du ${w[0]} au ${w[6]}`).join(", ");

      const msgPayload = {
        email: form.email,
        nom: form.nom,
        prenom: form.prenom,
        telephone: form.telephone,
        personnes: String(form.personnes),
        periodes,
        message,
      };
      const msgId = await saveMessage(msgPayload);

      const adminLink = `${window.location.origin}/admin?msg=${encodeURIComponent(msgId)}`;

      const templateParams = {
        ...msgPayload,
        admin_link: adminLink,
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      alert("✅ Votre demande a bien été envoyée !");
      setSelectedWeeks([]);
      setShowForm(false);
    } catch (err) {
      console.error("❌ Erreur :", err);
      alert("Erreur lors de l’envoi du message.");
    }
  };

  return (
    <div className="reservation-box">
      <h2>Réservation</h2>
      <h3>(Du Samedi au Samedi)</h3>

      <Calendar
        tileClassName={tileClassName}
        minDetail="month"
        locale="fr-FR"
        onClickDay={onClickDay}
        tileDisabled={tileDisabled}
      />

      {error && <p style={{ color: "red" }}>{error}</p>}

      <button onClick={handleReservation} className="btn-reserver">
        Réserver
      </button>

      {showForm && (
        <form className="formulaire" onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Votre Email"
            required
            onChange={handleChange}
          />
          <input type="text" name="nom" placeholder="Nom" onChange={handleChange} />
          <input
            type="text"
            name="prenom"
            placeholder="Prénom"
            onChange={handleChange}
          />
          <input
            type="number"
            name="personnes"
            placeholder="Nombre de personnes"
            onChange={handleChange}
          />
          <input
            type="tel"
            name="telephone"
            placeholder="Téléphone"
            onChange={handleChange}
          />

          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows="6"
          />

          <button type="submit" className="btn-envoyer">
            Envoyer
          </button>
        </form>
      )}
    </div>
  );
};

export default CalendrierMaison;
